export const LOAD_CABIN_CREW_ACTIVITY = 'LOAD_CABIN_CREW_ACTIVITY';
export const GET_CABIN_CREW_ACTIVITY = 'GET_CABIN_CREW_ACTIVITY';
export const CLEAR_CABIN_CREW_ACTIVITY = 'CLEAR_CABIN_CREW_ACTIVITY';